import React, { useState } from "react";
import "./PasswordInputField.css";
import OpenEye from '../../../assets/svg_main/eye-open.svg'
import CloseEye from '../../../assets/svg_main/eye-closed.svg'
import InfoBar from "../InfoBars";
import CustomTooltip from "../CustomTooltip";
interface PasswordInputProps {
  label: string;
  placeholder: string;
  onChange: (value: string) => void;
  inputType:string;
  errorMessage:string;
  tooltipNeeded?:boolean;
  toolTipText?:string;
}
 
const PasswordInput: React.FC<PasswordInputProps> = ({
  label,
  placeholder,
  onChange,
  inputType,
  errorMessage,
  tooltipNeeded,
  toolTipText
}) => {
  const [showPassword, setShowPassword] = useState(false);
 
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <div className="password_input_field_container">
      <label className="password_input_field_label">{label}
      {tooltipNeeded &&
          <span className='password_input_field_label_tooltip'><CustomTooltip text={toolTipText}/></span>
          }
      </label>
      <div className="password_input_field_div">
        <input
          type={showPassword ? "text" : "password"}
          className="password_input_field_input"
          placeholder={placeholder}
          onChange={handleChange}
          autoComplete="off"
        />
        <span
          className="password_input_field_icon"
          onClick={togglePasswordVisibility}
        >
          {showPassword ? <OpenEye/> : <CloseEye/>}
        </span>
      </div>
      <div className="input_field_infoBars">
        {inputType === 'success' ? (
          <InfoBar
            variant="success"
            message={errorMessage?errorMessage:'Success'}
            className="input_field_class"
          />
        ) : (
          ''
        )}
        {inputType === 'error' ? (
          <InfoBar
            variant="danger"
            message={errorMessage?errorMessage:''}
            className="input_field_class"
          />
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
 
export default PasswordInput;
 